module.exports = __webpack_public_path__ + "img/contact-backer.4e6b657e.jpg";